var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderStepper3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_469_8385)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.60938,
    y: 2.21875,
    width: 44,
    height: 44,
    rx: 22,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6968 27.1997L30.9301 23.4414C31.0089 23.0575 31.048 22.6666 31.0468 22.2747C31.0465 21.2003 30.7753 20.1432 30.2584 19.2013C29.7414 18.2593 28.9954 17.4629 28.0892 16.8857C27.183 16.3084 26.1459 15.9689 25.0737 15.8985C24.0016 15.8281 22.929 16.0292 21.9551 16.483C21.8317 16.5394 21.724 16.625 21.6412 16.7325C21.5584 16.84 21.5031 16.966 21.4801 17.0997C21.4572 17.2317 21.4664 17.3673 21.5071 17.4949C21.5477 17.6226 21.6185 17.7386 21.7134 17.833L25.3384 21.4497L23.8384 22.9497L20.2218 19.3247C20.1265 19.2312 20.0101 19.162 19.8825 19.1228C19.7549 19.0837 19.6198 19.0757 19.4884 19.0997C19.3556 19.1219 19.2301 19.1759 19.1227 19.2572C19.0153 19.3385 18.9292 19.4445 18.8718 19.5664C18.4164 20.5435 18.2155 21.6199 18.2878 22.6954C18.3602 23.771 18.7034 24.8108 19.2855 25.7181C19.8677 26.6254 20.6698 27.3707 21.6174 27.8848C22.5649 28.3988 23.6271 28.6648 24.7051 28.658C25.097 28.6593 25.4879 28.6202 25.8718 28.5414L29.6301 32.308C29.7076 32.3861 29.7997 32.4481 29.9013 32.4905C30.0028 32.5328 30.1118 32.5545 30.2218 32.5545C30.3318 32.5545 30.4407 32.5328 30.5423 32.4905C30.6438 32.4481 30.736 32.3861 30.8134 32.308C30.8915 32.2306 30.9535 32.1384 30.9958 32.0369C31.0382 31.9353 31.0599 31.8264 31.0599 31.7164C31.0599 31.6064 31.0382 31.4974 30.9958 31.3959C30.9535 31.2943 30.8915 31.2022 30.8134 31.1247L26.7301 27.0414C26.6281 26.94 26.5015 26.8668 26.3628 26.8288C26.2241 26.7908 26.0779 26.7894 25.9384 26.8247C25.5361 26.9325 25.1216 26.9885 24.7051 26.9914C24.0818 26.9969 23.4636 26.879 22.8861 26.6445C22.3085 26.4101 21.7831 26.0636 21.34 25.6252C20.8969 25.1868 20.545 24.665 20.3045 24.09C20.0639 23.515 19.9395 22.898 19.9384 22.2747C19.9374 21.9956 19.9597 21.7168 20.0051 21.4414L23.2718 24.7164C23.3492 24.7945 23.4414 24.8565 23.543 24.8988C23.6445 24.9411 23.7534 24.9629 23.8634 24.9629C23.9734 24.9629 24.0824 24.9411 24.1839 24.8988C24.2855 24.8565 24.3776 24.7945 24.4551 24.7164L27.1051 22.0414C27.2553 21.886 27.3393 21.6783 27.3393 21.4622C27.3393 21.2461 27.2553 21.0384 27.1051 20.883L23.8634 17.6164C24.1389 17.5714 24.4176 17.5491 24.6968 17.5497C25.9485 17.5519 27.1482 18.0507 28.0325 18.9366C28.9168 19.8224 29.4134 21.023 29.4134 22.2747C29.4105 22.6912 29.3545 23.1057 29.2468 23.508C29.2115 23.6475 29.2129 23.7937 29.2509 23.9324C29.2888 24.0711 29.3621 24.1977 29.4634 24.2997L33.5468 28.383C33.7037 28.54 33.9165 28.6281 34.1384 28.6281C34.3604 28.6281 34.5732 28.54 34.7301 28.383C34.887 28.2261 34.9752 28.0133 34.9752 27.7914C34.9752 27.5695 34.887 27.3566 34.7301 27.1997H34.6968Z",
    fill: "#9C4900"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_469_8385",
    x: 0.609375,
    y: 0.21875,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.575 0 0 0 0 0.563021 0 0 0 0 0.563021 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_469_8385"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_469_8385",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderStepper3);
export default __webpack_public_path__ + "static/media/HeaderStepper3.ba54ce28c79f0a7d4974cd0382bcc6bd.svg";
export { ForwardRef as ReactComponent };